/**
 * Orders module
 *
 * @version
 * 4.71.0 OAUI-685 Implement tabbed sections on table
 * 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.62.0 OAUI-630 Add Delivery Time Window to order details
 * 4.42.0 OAUI-555 Add dropdown to download attachments in work orders v2
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 * 4.35.0 OAUI-500 View order adjustments
 * 4.35.0 OAUI-499 View Order Messages
 * 4.35.0 OAUI-496 Add header and missing fields
 * 4.34.0 OAUI-479 Optimize the list orders page to avoid overloaded SCSS files
 * 4.31.0 OAUI-453 Set up basic list settings, filters and layout
 * 4.31.0 OAUI-452 Set up basic list orders routing
 * 4.26.0 OAUI-418 Hook up API calls for QR Code Order Management page
 * 4.26.0 OAUI-416 Add basic QR code order management route
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from 'src/app/components/shared.module';
import { ListV2Component } from './components/list-v2/list-v2.component';
import { ListComponent } from './components/list/list.component';
import { ListV2HeaderComponent } from './components/list-v2/header/header-v2.component';
import { ListTabsComponent } from './components/list-v2/tabs/tabs.component';
import { ListHeaderComponent } from './components/list/header/header.component';
import { ManageComponent } from './components/manage/manage.component';
import { ManageHeaderComponent } from './components/manage/header/header.component';
import { OrdersRoutingModule } from './orders-routing.module';
import { ListAttachmentsComponent } from '../../components/order-list-attachments/list-attachments.component';
import { OrderMessagesComponent } from '../../components/order-messages/order-messages.component';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    ListComponent,
    ListV2Component,
    ListHeaderComponent,
    ListV2HeaderComponent,
    ListTabsComponent,
    ManageComponent,
    ManageHeaderComponent,
    ListAttachmentsComponent,
    OrderMessagesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrdersRoutingModule,
    SharedModule,
    MatDialogModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatMenuModule,
    NgbTimepickerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrdersModule {}
